import { memo } from 'react';
import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { useSecurity } from '@dfl/react-security';
import { INCIDENCE_RESOLUTION_PERMISSIONS } from '../../constants';
import useUpdateRefundStatus from '../../hooks/useUpdateRefundStatus';
import { IIncidenceResolution } from '../../interfaces';
import { Box } from '@mui/material';
import { useFindResolutionStatuses } from 'modules/sales/settings/resolution-status/hooks/useFindResolutionStatuses';
import { useCheckLocale } from 'modules/sales/common/components/OrderStatusPicker/OrderStatusPicker';

type Props = {
  data: IIncidenceResolution;
};

const IncidenceResolutionStatus = ({ data }: Props) => {
  const { hasPermission } = useSecurity();
  const { updateStatus, isLoading } = useUpdateRefundStatus(data?._id as string);

  const { isLoading: isStatusLoading, isError, data: statuses } = useFindResolutionStatuses();

  const _value = useCheckLocale(data?.status as IStatus);

  return (
    <Box sx={{ '.MuiChip-root': { padding: '15px 10px', borderRadius: '50px' } }}>
      <StatusPicker
        readOnly={!hasPermission(INCIDENCE_RESOLUTION_PERMISSIONS.INCIDENCE_RESOLUTION_WRITE)}
        name='status'
        isError={isError}
        size={'small'}
        options={statuses?.data as IStatus[]}
        isLoading={isLoading || isStatusLoading}
        onChange={(status: any) => {
          updateStatus(status?._id);
        }}
        value={_value}
      />
    </Box>
  );
};

export default memo(IncidenceResolutionStatus);
